import { useState } from 'react'
import { useAdminApi } from '../api'
import { t } from '../i18n'
import { useLang } from '../LangContext'
import { Icon } from '../../styles/Icon'

// Petición del club, 2026-10-02: "añadir un nuevo jugador" sin tener que montar un Excel para dar de
// alta a una sola persona. El backend ya admitía `POST /admin/equipos/:id/miembros`, pero solo con un
// `persona_id` ya existente — ahora también acepta crear la persona a partir del nombre.
export function AnadirJugadorForm({ equipoId, onAdded }: { equipoId: string; onAdded: () => void }) {
  const api = useAdminApi()
  const lang = useLang()
  const [nombre, setNombre] = useState('')
  const [apellidos, setApellidos] = useState('')
  const [grupo, setGrupo] = useState<'con_ficha' | 'sin_ficha'>('con_ficha')
  const [fechaIncorporacion, setFechaIncorporacion] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    const nombreCompleto = [nombre, apellidos].filter(Boolean).join(' ')
    await api.post(`/admin/equipos/${equipoId}/miembros`, {
      nombre: nombreCompleto,
      grupo,
      fecha_incorporacion: fechaIncorporacion || undefined,
    })
    setNombre('')
    setApellidos('')
    setFechaIncorporacion('')
    onAdded()
  }

  return (
    <form onSubmit={handleSubmit}>
      <h4>{t('anadirJugadorManual', lang)}</h4>
      <input
        placeholder={t('nombre', lang)}
        required
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
      />
      <input
        placeholder={t('apellidos', lang)}
        value={apellidos}
        onChange={(e) => setApellidos(e.target.value)}
      />
      <select value={grupo} onChange={(e) => setGrupo(e.target.value as 'con_ficha' | 'sin_ficha')}>
        <option value="con_ficha">{t('conFichaOpcion', lang)}</option>
        <option value="sin_ficha">{t('sinFichaOpcion', lang)}</option>
      </select>
      <input
        type="date"
        aria-label={t('fechaIncorporacion', lang)}
        value={fechaIncorporacion}
        onChange={(e) => setFechaIncorporacion(e.target.value)}
      />
      <button type="submit"><Icon name="crear" />{t('anadirJugadorManual', lang)}</button>
    </form>
  )
}
